import api from "../api";

/* --------------------------------
   Supplier Orders
-------------------------------- */
export const getSupplierOrders = async (filters) => {
  const params = {
    page: filters.page,
    page_size: filters.pageSize,
    tab: filters.tab,
  };
  if (filters.fulfillmentStatus) {
    params.fulfillment_status = filters.fulfillmentStatus;
  }
  if (filters.shipmentStatus) {
    params.shipment_status = filters.shipmentStatus;
  }
  if (filters.dateFrom) {
    params.date_from = filters.dateFrom;
  }
  if (filters.dateTo) {
    params.date_to = filters.dateTo;
  }
  if (filters.minAmount) {
    params.min_amount = filters.minAmount;
  }
  if (filters.maxAmount) {
    params.max_amount = filters.maxAmount;
  }
  if (filters.deliveryMethod) {
    params.delivery_method = filters.deliveryMethod;
  }
  if (filters.search) {
    params.search = filters.search;
  }
  const response = await api.get("operation/supplier/orders/", { params });
  return response.data;
};


export const getSupplierOrderDetail = async (orderId) => {
  const response = await api.get(`operation/supplier/orders/${orderId}/`);
  return response.data;
};

/* --------------------------------
   Processing Shipments
-------------------------------- */
export const getProcessingShipments = async (filters) => {
  const params = {
    page: filters.currentPage,
    page_size: filters.pageSize,
  };

  if (filters.warehouse) params.warehouse = filters.warehouse;
  if (filters.search) params.search = filters.search;
  if (filters.ordering) params.ordering = filters.ordering;
  if (filters.status) params.status = filters.status;

  if (filters.isPinned !== undefined && filters.isPinned !== null && filters.isPinned !== "") {
    params.is_pinned = filters.isPinned;
  }

  const response = await api.get(
    "operation/supplier/processing-shipments/",
    { params }
  );
  return response.data;
};

export const getProcessingShipmentDetail = async (shipmentCode) => {
  const response = await api.get(
    `operation/supplier/processing-shipments/${shipmentCode}/`
  );
  return response.data;
};

/* --------------------------------
   Shipment Actions
-------------------------------- */
export const approveShipment = async (shipmentCode, data) => {
  const response = await api.post(
    `operation/supplier/processing-shipments/${shipmentCode}/approve/`,
    data
  );
  return response.data;
};

export const markShipmentReady = async (shipmentCode) => {
  const response = await api.post(
    `operation/supplier/processing-shipments/${shipmentCode}/ready/`
  );
  return response.data;
};

export const handoverShipment = async (shipmentCode) => {
  const response = await api.post(
    `operation/supplier/processing-shipments/${shipmentCode}/handover/`,
  );
  return response.data;
};

export const deliverShipment = async (shipmentCode, data) => {
  const response = await api.post(
    `operation/supplier/processing-shipments/${shipmentCode}/deliver/`,
    data
  );
  return response.data;
};


export const getSupplierWarehouses = async () => {
  const response = await api.get("/products/warehouses-address/");
  return response.data;
};

export const toggleProcessingShipmentPin = async (shipmentCode, isPinned) => {
  const response = await api.post(
    `operation/supplier/processing-shipments/${shipmentCode}/pin/`,
    {
      is_pinned: isPinned,
    }
  );

  return response.data;
};


